import React from 'react';
import __ from 'lodash';

class KelasDropdown extends React.Component{
    state = {idKelas: ''};

    renderDropdown(){
        console.log("DATA KELAS :::")
        console.log(this.props.kelas);
        if(!__.isEmpty(this.props.kelas)){
            return this.props.kelas.map((kel) => {
                return (
                    <option value={kel.idKelas}>{kel.namaKelas}</option>
                )
            })
        }
    }

    onDropdownChange = (event) => {
        console.log(event.target.value);
        if(event.target.value === ""){
            this.props.onChange(null);
        }else{
            this.props.onChange(event.target.value);
        }
    }

    render(){
        return(
            <div>
            <select className="form-control" onChange={this.onDropdownChange}>
                <option value="">Semua kelas</option>
                {this.renderDropdown()}
            </select>
            </div>
        )
    }
}

export default KelasDropdown;